export const locale = {
    lang: 'nl',
    data: {
      'RESULTADOS': {
        'TITULO': 'VERSLAGLEGGING',
        'DESCRIP': 'Selecteer een optie',
        'CARGANDO': 'Belading van de resultaten van de bedrijfsenquête',
        'COMINGSOON': 'COVID-enquêteresultaten komen binnenkort...',
        'VALIDANDO': {
          'BOTON': 'Op het validatieproces',
          'MENSAJE': 'De resultaten van dit product zijn in behandeling, ze zullen binnenkort beschikbaar zijn',
        },
        'TABLAPRODUCTOS':{
          'COL1': 'Jaar',
          'COL2': 'Toegang',
          'BOT': 'Toegang',
        },

        'SECCIONES': {
          'TITULO_VER': 'Versie',
          'NOSECCIONES': 'Er zijn geen secties beschikbaar',

          'CERTIFICAR': {
            'TITULO': 'CERTIFICEREN',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'MEDIR': {
            'TITULO': 'METING',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'MEDIR_INNO': {
            'TITULO': 'Innmotion enquête',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'CertiAdicio': {
            'TITULO': 'AANVULLENDE CERTIFICERINGEN',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'TrabDign': {
            'TITULO': 'WAARDIG WERK',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'PrimEmp': {
            'TITULO': 'EERSTE BAAN',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
          'GOFLOW': {
            'TITULO': 'GoFlow Resultaten',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Enter'
          },
        },

        'TABPRIN':{
          'TABPRO': 'Certificeringsprocessen',
          'TAB4ALL': 'FORALL-resultaten',
          'TAB4ALL2': 'Procesresultaten',
          'TITUREN': 'VOORNAAMSTE RESULTATEN',
          'TABCER': 'Meetproces',
          'TABPULSE': 'Pulscontroleprocessen',
          'TABICI': 'ICI-resultaten',
          'TABINNO': 'Innmotion enquête-resultaten',
          'TABAMCO': 'AMCO-processen',
          'TABTRABDIG': 'Processen inzake fatsoenlijk werk',
          'TABPRIEMP': 'Eerste werkgelegenheidsprocessen',

        },
        'TABPRIN5':{
          'TABPRO': 'Globaal versie 3.1-proces',
          'TAB4ALL': 'FORALL-resultaten',
          'TAB4ALL2': 'FORALL-proces',
          'TITUREN': 'VOORNAAMSTE resultaten',
          'TABCER': 'Lider versie 3.2 Lider proces',
          'TABPULSE': 'Covid versie 3.3 proces',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL geërfde resultaten',
         'BOTON': 'Start',
         'SIN_4ALL_HEREDADAS': 'U rekent niet op geërfde FORALL-resultaten',
         'TITULOCERTIFICAAR': 'Certificeren',
         'APLICACIONANIO':'Sollicitatiejaar: 2019',
        },
        '4ALL':{
            'CARGANDO': 'Laden van de resultaten van FORALL',
             'TITULO4ALL': 'OEFENRESULTATEN',
             'TABPRACTICA':{
              'TITULOTAB': 'Practices 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC': 'Globaal resultaat van FORALL-praktijken',
              'TEXTO1': 'Percentage van ',
              'TEXTO2': 'kennis van FORALL-praktijken',
              'TEXTO3': 'in uw organisatie',
              'TEXTO4': 'Niveau van',
              'TEXTO5': 'tevredenheid van de medewerkers die ze kennen',
              'TEXTO6': 'FORALL-praktijken',
            },
            'TITULOPRAC4All':{
              'TITULOTAB': 'Demografie',
              'SUBTITULO4ALL': 'Resultaten door FORALL-praktijken',
              'TITULOCONO': 'KENNIS',
              'TEXTO1': 'Kennispercentage van FORALL-praktijken in uw organisatie',
              'TITULOSATIS': 'TEVREDENHEID',
              'TEXTO2': 'Tevredenheid van medewerkers die de FORALL-praktijk kennen',
            }
          },

        'DEMOGRAFICOS':{
          'Cargo homologado': 'Goedgekeurde positie',
          'Años de Trabajo': 'Antiek',
            'Condición de trabajo': 'Arbeidsvoorwaarde',
            'Tipo de trabajo': 'Compensatieregeling',
            'Género': 'Geslacht',
            'Educación': 'Academische graad',
            'PORCONOTXT1': 'Percentage van',
            'PORCONOTXT2': 'kennis van FORALL-praktijken',
            'PORCONOTXT3': 'door demografische reductie',
            'PORSATITXT1': 'Niveau van',
            'PORSATITXT2': 'tevredenheid van de medewerkers die de FORALL-praktijken kennen',
            'PORSATITXT3': 'door demografie',
         },
         'MODL_N_RESU':'Er zijn momenteel geen resultaten',
         'MODL_N_RESU_4ALL':'Kan de gevraagde resultaten niet weergeven',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":"Geen resultaat platformKey gevonden",
            "ETQ_PROD": "Product: ",
            "ETQ_BROK": "Broker: ",
            "ETQ_COUN": "Land: ",
            "ETQ_LANG": "Taal: ",
            "ETQ_CERTY": "Certificaat: ",
            "true": "Enabled",
            "false": "Disabled",
            "COUNTR_NO_SELEC":"*Niet geselecteerd*",
         }
      },
      'RESULTADOS_5':{
        'TITULO': 'Resultaten 5.0',
        'SECCIONES': {
          'NOSECCIONES': 'Niet beschikbaar',
          '31': {
            'TITULO': 'globale versie 3.1',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Ga'
          },
          '32': {
            'TITULO': 'Leader versie 3.2',
            'INFO': 'Selecteer het jaar dat u wilt raadplegen',
            'BOTON': 'Ga'
          },
          '33': {
            'TITULO': 'Covid versie 3.3',
            'INFO': 'Selecteer het jaar dat u wilt consuleren',
            'BOTON': 'Ga'
          }
        },
      },
      'CONFING_RESUL':{
      'TITULO_MODAL':'BenchMarks resultaten configuratie',
      'TAB_DEMO_EXCEL':'Excel-demografie',
      'SUB_TIT_TAB_DEMO_EXCEL':'Selecteer demografie:',
      'TAB_DEMO_ENCU':'Demografische enquête',
      'SUB_TIT_TAB_DEMO_ENCU':'Selecteer demografische gegevens:',
      'TAB_BENCHMA':'BenchMark',
      'SUB_TIT_TAB_BENCHMA':'',
      'TITULO_MAT_EXPAN_TAMANO':'Top',
      'TITULO_MAT_EXPAN_SECTOR':'Sectoraal',
      'TITULO_MAT_EXPAN_REGIONAL':'Ranges',
      'OKSELECT': 'Geselecteerd',
      'NOTSELECT': 'Niet geselecteerd',
      'TAB_NIV_GEOG':'Geografische niveaus',
      'SUB_TIT_TAB_NIV_GEOG':'Selecteer geografische niveaus:',
      'TAB_NIV_ESTRUC':'Structurele niveaus',
      'SUB_TIT_TAB_NIV_ESTRUC':'Selecteer de structurele niveaus:',
      'BTN_ACEPTAR':'Accepteren',
      'MODAL_CARGA_DEMO_EXC':'Demografische gegevens aan het laden',
      'MODAL_CARGA_DEMO_ENC':'Enquêtes demografische gegevens laden',
      'MODAL_CARGA_BENCH':'Benchmark laden',
      'MODAL_CARGA_NIV_GEO':'Geografische niveaus laden',
      'MODAL_CARGA_NIV_ESTR':'Structurele niveaus laden',
      'TAB_BENCH_MARK':'Benchmark',
      'MODAL_CARGA_BENCH_MARK': 'Benchmark aan het laden',
      'SUB_TIT_TAB_BENCH_MARK': 'Selecteer Benchmark:',
      'SUCCES_GUAR_SELEC':'De wijzigingen werden correct opgeslagen',
      'CONFI_GUAR_SELE': 'Weet u zeker dat u de aangebrachte wijzigingen wilt opslaan?',
      'RES_SI': 'Ja',
      'RES_NO': 'Nee',
      'MAT_TOOL_BTN_CONFI_RESULT':'Resultaten configuratie',
      'MODAL_GUA_INFOR':'Opslaan van informatie',
      'SUB_TIT_TAB_HIERARCHI': 'Selectie HiërarchischePaden:',
      'MODAL_CARGA_HIERARCHI':'Laden van HiërarchischePaden',
      'SIN__HIERARCHI_MOSTRAR': 'Er zijn momenteel geen resultaten in hiërarchischepaden',
      'EXTERNAL_PORTAL':'Kopieer de url van de externe 4all',
      'INTRU_TEX_BENCHMARK':'*Verplaats Benchmarks',
      'BENCHMARCK_SELEC':'BenchMark geselecteerd in volgorde van presentatie:',
      'BTN_SAV_BENCH':'BenchMarks opslaan',
      'TEX_SEARC_BENCH_TOP':'Voer top Benchmark in om te zoeken',
      'TEX_SEARC_BENCH_SECT':'Sector Benchmark invoeren om te zoeken',
      'TEX_SEARC_BENCH_RANG':'Voer Benchmarkbereik in om te zoeken',
      'INFO_MAS_BENCH_ESPA':'gegroepeerde benchmarks',
      'BTN_ADD_BENCH_SUGE':'Voorstellen toevoegen',
      'MOD_WARN_MAX_PERMIT':'Toevoegen is niet mogelijk omdat het aantal toegestane spaties wordt overschreden',
      'MOD_WARN_UN_CATE':'Momenteel bestaat er al een Benchmarks van de geselecteerde catergorie',
      'MOD_WARN_NO_APLIC':'Toevoegen is niet mogelijk, omdat de optie om de BenchMarks niet te selecteren is ingeschakeld.',
      'INSTRU_DRAP&DROP_1':'Sleep BenchMark hierheen',
      'LABE_CIRC_PROGRE':'Benchmarks',
      'LABE_INSTRU_SELECT_BENCH':'¿Wilt u BenchMarks selecteren?',
    },
    'CONFING_RESUL_GOFLOW':{
    'TITULO_MODAL':'Informatie over GoFlow-resultaten',
      },
    'CONFING_RESUL_EMP':{
    'TITULO_MODAL': 'Ruwe gegevens Emprising',
      'INT_TEX': 'Instructie: Upload het te importeren bestand met ruwe gegevens',
      'TOOLT_CHA_INF':'Ik heb het bestand geselecteerd',
      'UPLO_INF': 'Rijgegevens worden geïmporteerd',
      'SUCC_UPLO_INF':'Met succes geïmporteerd',
    }
  }
};
